import { render } from "./ActualityComponent.vue?vue&type=template&id=2f082d67"
import script from "./ActualityComponent.vue?vue&type=script&lang=js"
export * from "./ActualityComponent.vue?vue&type=script&lang=js"

import "./ActualityComponent.vue?vue&type=style&index=0&id=2f082d67&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__